import {ExpressCheckoutController} from '@wc-stripe/controllers';
import {getSetting} from '@wc-stripe/utils';
import Context from '@wc-stripe/context';
import {ApplePayGateway} from '@wc-stripe/gateways'

const settings = getSetting('stripe_applepay_data');

const context = new Context('express_checkout');

const gateway = new ApplePayGateway({
    id: 'stripe_applepay',
    settings,
    context
});

const controller = new ExpressCheckoutController({
    context,
    gateway,
    selector: '.banner_payment_method_stripe_applepay'
});

controller.initialize();